<template>
  <button @click="exportTransaction" class="btn btn-info is-border-1 mr-1 mb-2">
    <i class="fa fa-download"></i>
    {{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <span>{{ $t('exportNotice') }}</span>
      </div>
      <b-progress :max="totalCount">
        <b-progress-bar :value="downloadedCount"
                        :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
      </b-progress>
    </b-modal>
  </button>
</template>


<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      cancelRequest: false,
      downloadedCount: 0
    }
  },
  methods: {
    exportTransaction: async function () {
      this.downloadedCount = 0;
      this.exporting = true;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('data');
      this.setupSheet(sheet);

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        if (this.cancelRequest) {
          break;
        }
        let result = await this.$service.get('/chat-auto-reply', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let status = '';
          if (!item.sendTime) {
            status = this.$t('notYetSent');
          }
          if (item.sendTime && !item.error) {
            status = this.$t('sent');
          }
          if (item.sendTime && item.error) {
            status = this.$t('sentFail');
          }
          let row = {
            domain: item.client && item.client.domain ? item.client.domain : '',
            account: item.account && item.account.name && item.account.type ? `${this.$t(item.account.type)}: ${item.account.name}` : this.$t('unknown'),
            bot: item.bot && item.bot.name ? item.bot.name : '',
            customer: item.customer && item.customer.name ? item.customer.name : this.$t('unknown'),
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm:ss'),
            sendTime: moment(item.sendTime).format('DD/MM/YYYY HH:mm:ss'),
            type: item.type === 'chatbot' ? 'Chatbot' : this.$t('autoReply'),
            status: status,
            errorMsg: item.errorMsg ? item.errorMsg : ''
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'chatbot-history.xlsx');
      }).finally(() => {
        this.cancelRequest = false;
        this.downloadedCount = 0;
      });
    },
    setupSheet: function (sheet) {
      sheet.columns = [
        {header: 'Domain', key: 'domain', width: 20},
        {header: this.$t('socialNetworkAccount'), key: 'account', width: 15},
        {header: this.$t('botName'), key: 'bot', width: 20},
        {header: this.$t('customer'), key: 'customer', width: 15},
        {header: this.$t('createTime'), key: 'createTime', width: 20},
        {header: this.$t('sendTime'), key: 'sendTime', width: 20},
        {header: this.$t('type'), key: 'type', width: 15},
        {header: this.$t('status'), key: 'status', width: 15},
        {header: this.$t('sendErrorMsg'), key: 'errorMsg', width: 15},
      ];
    },
    close() {
      this.cancelRequest = true;
    }
  },
  i18n: {
    messages: {
      en: {
        chatBot: "Chatbot",
        autoReply: "Auto reply",
        question: "Question",
        theAnswer: "Answer",
        account: "Account",
        customer: "Customer",
        error: "Error",
        socialNetworkAccount: "Social network accounts",
        botName: "Bot name",
      },
      vi: {
        chatBot: "Chatbot",
        autoReply: "Trả lời tự động",
        question: "Câu hỏi",
        theAnswer: "Câu trả lời",
        account: "Tài khoản",
        customer: "Khách hàng",
        error: "Có lỗi",
        socialNetworkAccount: "Tài khoản mạng xã hội",
        botName: "Tên bot",
      }
    }
  }

}
</script>